import { useTimeOffPermissions } from 'hooks/useTimeOffPermissions.hook';
import { canShowCreateActionInColumn } from 'utils/predicates/scheduler/canShowCreateActionInColumn.util';

/**
 * Hides "Book time off" when can_create_time_off is no_access, or personal on another stylist's column.
 */
export const BookTimeOffGatedByPermissions = ({ columnStylistId, onClick, label, dataBem, className }) => {
  const timeOffPerms = useTimeOffPermissions();

  if (!canShowCreateActionInColumn({ columnStylistId, ...timeOffPerms })) return null;

  return (
    <button data-bem={dataBem || undefined} data-testid={`BookTimeOffGatedByPermissions-${columnStylistId}`} onClick={onClick} className={className} type="button">
      {label}
    </button>
  );
};
